import { Controller } from 'stimulus';

/**
 * For PWA users, their notification badge count should be in sync with the
 * organisation alert count in the header.
 *
 * When they receive a notification, the service worker will increment the count.
 *
 * In order to decrement it, this controller will detect the change in number,
 * then post the new count to the service worker for update.
 */
export default class extends Controller {
  static values = { count: Number };

  async countValueChanged(newValue) {
    this.registration = await this.ensureRegistration();

    if (!this.registration) return;

    this.registration.active.postMessage({
      key: 'set_badge_count',
      count: newValue,
    });
  }

  async ensureRegistration() {
    try {
      let registration = await navigator.serviceWorker.getRegistration(
        '/firebase-messaging-sw.js'
      );

      if (!registration) {
        registration = await navigator.serviceWorker.register(
          '/firebase-messaging-sw.js'
        );

        // Wait for activation if needed
        if (navigator.serviceWorker.ready) {
          await navigator.serviceWorker.ready;
        }
      }
      return registration;
    } catch (error) {
      window.appsignal.sendError(`ensureRegistration error: ${error}`);
      return null;
    }
  }
}
